import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const GoogleColor = ({
  size,
  color,
  width,
  height,
  x = '0px',
  y = '0px',
  scale = 0,
}: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '40px'}
      height={size || '40px'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 40 40"
      fill={color || 'currentColor'}
    >
      <path
        fill="#4285F4"
        d="M38.666,20.857c0-1.351-0.121-2.651-0.347-3.898H20.37v7.381h10.257c-0.45,2.374-1.802,4.384-3.829,5.735 v4.799h6.185C36.587,31.547,38.666,26.661,38.666,20.857z"
      />
      <path
        fill="#34A853"
        d="M20.37,39.482c5.146,0,9.46-1.698,12.613-4.609l-6.185-4.799c-1.698,1.144-3.864,1.837-6.428,1.837
        c-4.955,0-9.166-3.344-10.673-7.849H3.356v4.921C6.492,35.203,12.92,39.482,20.37,39.482z"
      />
      <path
        fill="#FBBC05"
        d="M9.697,24.045c-0.381-1.144-0.606-2.356-0.606-3.621s0.225-2.478,0.606-3.621v-4.921H3.356
        c-1.299,2.564-2.044,5.458-2.044,8.542s0.745,5.978,2.044,8.542l4.938-3.846C8.294,25.119,9.697,24.045,9.697,24.045z"
      />
      <path
        fill="#EA4335"
        d="M20.37,8.954c2.807,0,5.302,0.97,7.294,2.841l5.458-5.458c-3.309-3.084-7.606-4.973-12.752-4.973
        c-7.45,0-13.878,4.28-17.014,10.517l6.341,4.921C11.204,12.298,15.415,8.954,20.37,8.954z"
      />
    </StyledSvg>
  );
};
